import { render, staticRenderFns } from "./FormAExport.vue?vue&type=template&id=05203570&scoped=true"
import script from "./FormAExport.vue?vue&type=script&lang=js"
export * from "./FormAExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05203570",
  null
  
)

export default component.exports